import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormSelect } from "src/app/components/form/SimpleFormSelect";
import { useFrequencyOptions, useSiteByManagerOptions, useWordCountOptions } from "src/app/hooks";
import { OrderTransport } from "src/app/transports/order";
import { UpsertPublishOn, upsertPublishOnSchema } from "src/app/types/orders/order";

export interface IPublishOnContainer {
    selectedRows: any[];
    handlerValueToUpdateGrid(update: boolean): void;
    handleClose(): void;
    showModal: boolean;
}
const PublishOnContainer = (props: IPublishOnContainer) => {
    const { selectedRows, handlerValueToUpdateGrid, handleClose, showModal } = props;
    const { formatMessage } = useIntl();
    const { siteByManagerOptions, loading: siteByManagerLoading } = useSiteByManagerOptions();
    const { frequencyOptions } = useFrequencyOptions();
    const { wordCountOptions } = useWordCountOptions();
    const [loading, setLoading] = useState(false);
    const onSubmit = async (_values: UpsertPublishOn) => {
        const valuesToSubmit = selectedRows.map((row) => ({
            ...OrderTransport.formTransformer(row),
            ..._values,
        }));
        setLoading(true);
        try {
            await OrderTransport.publishOn(valuesToSubmit);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handlerValueToUpdateGrid(true);
            handleClose();
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.action.publishOn" })}
            showModal={showModal}
            handleClose={handleClose}
            formId="publishOn"
            loading={loading}
            modalProps={{ size: "sm" }}
        >
            <Formik
                initialValues={upsertPublishOnSchema.getDefault()}
                validationSchema={upsertPublishOnSchema}
                onSubmit={(values: object) => onSubmit(values as UpsertPublishOn)}
            >
                <Form id="publishOn">
                    <SimpleFormSelect
                        isClearable={false}
                        name="moneySiteId"
                        isLoading={siteByManagerLoading}
                        label={formatMessage({ id: "common.field.moneySite" })}
                        values={siteByManagerOptions}
                    />
                    <SimpleFormSelect
                        isClearable={false}
                        name="wordCount"
                        label={formatMessage({ id: "common.field.wordsCount" })}
                        values={wordCountOptions}
                    />
                    <SimpleFormSelect
                        isClearable={false}
                        name="frequency"
                        label={formatMessage({ id: "common.field.frequency" })}
                        values={frequencyOptions}
                    />
                </Form>
            </Formik>
        </SimpleModal>
    );
};

export default PublishOnContainer;
